import { render, staticRenderFns } from "./ExpandableText.vue?vue&type=template&id=34a3ac1f&"
import script from "./ExpandableText.vue?vue&type=script&lang=js&"
export * from "./ExpandableText.vue?vue&type=script&lang=js&"
import style0 from "./ExpandableText.vue?vue&type=style&index=0&id=34a3ac1f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports